export default __webpack_public_path__ + "efd84c43af1f99c2538657c5dc46ea1d.png";